@import '../../global/styles/markers/marker';

:host {
  .lgr-marker {
    min-width: var(--lgr-spacing-xxs);
  }

  p {
    margin: var(--lgr-spacing-quarck) var(--lgr-spacing-nano);
  }
}
